var _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0001,
    cy: 12,
    rx: 12.0001,
    ry: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 16.5904L9.33842 13.3677L6.11572 11.7566L9.33842 10.1455L10.9495 6.9228L12.5606 10.1455L15.7833 11.7566L12.5606 13.3677L10.9495 16.5904ZM8.33602 11.7566L10.0782 12.6279L10.9495 14.3701L11.8209 12.6279L13.563 11.7566L11.8209 10.8852L10.9495 9.14308L10.0782 10.8852L8.33602 11.7566ZM14.9214 16.4732L15.6662 17.9626L16.4109 16.4732L17.9004 15.7285L16.4109 14.9837L15.6662 13.4943L14.9214 14.9837L13.432 15.7285L14.9214 16.4732ZM15.5832 8.36409L16.1626 9.52239L16.742 8.36409L17.9004 7.78469L16.742 7.2053L16.1626 6.047L15.5832 7.2053L14.4249 7.78469L15.5832 8.36409Z",
    fill: "url(#paint0_linear_15992_5560)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15992_5560",
    x1: 12.008,
    y1: 6.047,
    x2: 12.008,
    y2: 17.9626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B5F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.17e5e1b370b5927bcaf230726b3455ee.svg";
export { ForwardRef as ReactComponent };